import { m, type MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';

const CSS = {
	sidebar: 'c-Sidebar',
};

const styles = {
	[CSS.sidebar]: {
		width: '20%',
		'min-width': '350px',
		display: 'flex',
		'flex-direction': 'column',
	},
};

addStyles(styles);

export class Sidebar {
	view(children?: MithrilVNode | MithrilVNode[]) {
		return m(
			'div',
			{
				className: CSS.sidebar,
			},
			children
		);
	}
}
